import { render, staticRenderFns } from "./Projektphasen.vue?vue&type=template&id=d8bc9bd8&scoped=true&"
import script from "./Projektphasen.vue?vue&type=script&lang=js&"
export * from "./Projektphasen.vue?vue&type=script&lang=js&"
import style0 from "./Projektphasen.vue?vue&type=style&index=0&id=d8bc9bd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8bc9bd8",
  null
  
)

export default component.exports